import type {ClassValue} from "clsx"
import {clsx} from "clsx"
import {twMerge} from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export const formatPrice = (value: number, currency: string = "USD"): string => {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency,
    });

    return formatter.format(value);
};

export interface Option {
    label: string;
    value: string;
}

